// extracted by mini-css-extract-plugin
export var typingIndicator = "_q6-0";